import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  CreateEuTaxonomyCompanyActivityDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_EU_TAXONOMY_ACTIVITY } from "../domain";

import { euTaxonomyCompanyActivityApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_COMPANY_ACTIVITY = "CREATE_COMPANY_ACTIVITY";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

type CreateEuTaxonomyCompanyActivityRequest = CreateEuTaxonomyCompanyActivityDto;

const createCompanyActivity = async (
  data: CreateEuTaxonomyCompanyActivityDto,
): Promise<void> => {
  const response =
    await euTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerCreateEuTaxonomyCompanyActivity(
      data,
    );

  return response.data;
};

export const useCreateCompanyActivity = (
  user: UserProfileDto | null,
): {
  createCompanyActivity: UseMutateFunction<
    void,
    Error,
    CreateEuTaxonomyCompanyActivityRequest,
    unknown
  >;
  createCompanyActivityEnabled: boolean;
  isSuccessCreateCompanyActivity: boolean;
  isPendingCreateCompanyActivity: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_EU_TAXONOMY_ACTIVITY, ACTION_CREATE_COMPANY_ACTIVITY],
    mutationFn: enabled ? createCompanyActivity : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_EU_TAXONOMY_ACTIVITY] });
    },
  });

  return {
    createCompanyActivity: mutate,
    createCompanyActivityEnabled: enabled,
    isSuccessCreateCompanyActivity: isSuccess,
    isPendingCreateCompanyActivity: isPending,
  };
};
